



























































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Generate extends Vue {
    show = false
    showUrl = false
    generatedUrl = ''
    name = ''
    address = ''
    amount = ''
    message = ''

    created() {
        this.$ga.page('/bmac/generate')
    }

    check(ref: string) {
        const ele = this.$refs[ref] as HTMLInputElement
        if (!ele.checkValidity()) {
            ele.parentElement!.classList.add('error')
        } else {
            ele.parentElement!.classList.remove('error')
        }
    }

    validate() {
        const keys = Object.keys(this.$refs)
        const elems = keys.map((item) => {
            return this.$refs[item] as any
        })
        elems.forEach((item: HTMLInputElement) => {
            if (!item.checkValidity()) {
                item.parentElement!.classList.add('error')
            } else {
                item.parentElement!.classList.remove('error')
            }
        })
        return !elems.some((item) => {
            return item.validity.valid === false
        })
    }
    async createUrl() {
        if (!this.validate()) {
            return
        }
        const query = `name=${this.name}&addr=${this.address}&amount=${this.amount}&msg=${this.message}`
        this.generatedUrl = encodeURI(window.location.origin + `/donate?${query}`)
        this.showUrl = true
        await this.$nextTick()
        const urlEle = this.$refs.url as HTMLInputElement
        urlEle.select()
        document.execCommand('copy')
        this.show = true
        setTimeout(() => {
            this.show = false
        }, 3000)
    }
}
